import numeralHelper from '@/helpers/NumeralHelper';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'StateFactsheet',
  data() {
    return {
      hasAssets: false
    };
  },
  computed: {
    ...mapState({
      geographyTemplate: 'geographyTemplate'
    }),
    ...mapGetters({
      selectedItemValue: 'mapTemplate/selectedItemValue'
    })
  },
  methods: {
    getValue(field) {
      const locationData = this.geographyTemplate.locationData;
      if (locationData) {
        return locationData[field];
      }
      return;
    },
    getValueAsset(i, field) {
      const assets = this.geographyTemplate.assetsState;
      const locationData = this.geographyTemplate.locationData;
      if (assets.length >= i + 1 && locationData) {
        let item = locationData[assets[i][field]];
        if (item) {
          this.hasAssets = true;
        }
        return item;
      }
      return;
    },
    getFactoid(i, field) {
      const factoids = this.geographyTemplate.factoidsState;
      if (factoids.length >= i + 1) {
        if (field === 'label') {
          return factoids[i].label;
        }
        const value = this.getValue(factoids[i].field.toUpperCase());
        console.log(value);
        if (value !== null) {
          const formattedValue = numeralHelper.getFormattedNumber(
            value,
            factoids[i].field,
            'currencyFormat'
          );
          return formattedValue;
        }
        return "";
      }
    },
    getPromoData() {
      const locationData = this.geographyTemplate.locationData;
      const promoType = this.geographyTemplate.promoInfo.toLowerCase();
      if (locationData && promoType && this.geographyTemplate.promoInfoTypes[promoType]) {
        return this.geographyTemplate.promoInfoTypes[promoType];
      }
      return this.geographyTemplate.promoInfoTypes['default'];
    }
  }
};
